import { doc, getDoc } from 'firebase/firestore'
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut } from 'firebase/auth'
import { db, myFirebase } from '../system/firebase/index'
import { requestLogin, loginError, requestLogout, receiveLogout, logoutError, verifyRequest, setAuthUser, receiveLogin, verifySuccess, verifyFail } from '../system/redux/reducers/auth'
import { setPermissionsTier } from '../system/redux/reducers/user'

export const loginUser = (dispatch, params) => {
    dispatch(requestLogin())
    const auth = getAuth(myFirebase)
    return signInWithEmailAndPassword(auth, params.email, params.password)
        .then(async (data) => {
            await verifyAuth(dispatch)
            return true
        })
        .catch((error) => {
            // console.log(error)
            // Do something with the error if you want!
            dispatch(loginError())
            return false
        })
}

export const logoutUser = (dispatch) => {
    dispatch(requestLogout())
    const auth = getAuth(myFirebase)
    signOut(auth)
        .then(() => {
            dispatch(receiveLogout())
        })
        .catch((error) => {
            // Do something with the error if you want!
            dispatch(logoutError())
        })
}

export const verifyAuth = (dispatch) => {
    dispatch(verifyRequest())
    const auth = getAuth(myFirebase)
    onAuthStateChanged(auth, (user) => {
        if (user !== null) {
            const docRef = doc(db, 'users', user.uid)
            getDoc(docRef).then((userDoc) => {
                if (userDoc.exists()) {
                    const permissionDocRef = doc(db, 'settings', 'permissions')
                    getDoc(permissionDocRef).then((permDoc) => {
                        if (permDoc.exists()) {
                            const userData = JSON.stringify(userDoc.data())
                            const userSerialized = JSON.stringify(user)
                            const { tier } = permDoc.data()
                            dispatch(setPermissionsTier(tier))
                            dispatch(setAuthUser(userData))
                            dispatch(receiveLogin(userSerialized))
                            dispatch(verifySuccess())
                        }
                    })
                } else {
                    dispatch(loginError())
                }
            })
        } else {
            dispatch(verifyFail())
        }
    })
}

export const updateAuth = async (uid, data) => {
    if (typeof window !== 'undefined') {
        const payload = {
            uid: uid,
            data: data,
        }

        const { firebaseFunctionCall } = await import('../system/firebase/useFunctions')
        const updateAuth = firebaseFunctionCall('updateAuth')
        const updateUser = firebaseFunctionCall('updateUser')
        if (data.email) {
            updateAuth(payload)
                .then(() => {
                    updateUser(uid, { email: data })
                })
                .catch((error) => {
                    console.log(error);
                })
        }
        if (data.password) {
            updateAuth(uid, { password: data.password })
                .then(() => {
                    // console.log('Success')
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    }
}
